// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__3PkkQ","summary":"CartItem_summary__20yMf","price":"CartItem_price__VU6zU","amount":"CartItem_amount__342lc","actions":"CartItem_actions__2BYNy"};